import React from 'react';
import { FaShieldAlt, FaRupeeSign, FaUserCheck, FaFileSignature, FaPiggyBank } from 'react-icons/fa';
import './PmsbyScheme.css';

const PmsbyScheme = () => {
  return (
    <div className="pmsby-container">
      <div className="pmsby-header">
        <h1>प्रधानमंत्री सुरक्षा बीमा योजना (PMSBY)</h1>
        <p className="scheme-tagline">केवल ₹12 प्रति वर्ष में दुर्घटना बीमा सुरक्षा</p>
        <div className="official-link">
          <a href="https://www.myscheme.gov.in/schemes/pby" target="_blank" rel="noopener noreferrer">
            आधिकारिक योजना वेबसाइट ↗
          </a>
        </div>
      </div>

      <div className="pmsby-highlights">
        <div className="highlight-card">
          <div className="highlight-icon-container">
            <FaRupeeSign className="highlight-icon" />
          </div>
          <div className="highlight-text">₹2 लाख कवरेज</div>
        </div>
        <div className="highlight-card">
          <div className="highlight-icon-container">
            <FaShieldAlt className="highlight-icon" />
          </div>
          <div className="highlight-text">दुर्घटना सुरक्षा</div>
        </div>
        <div className="highlight-card">
          <div className="highlight-icon-container">
            <FaPiggyBank className="highlight-icon" />
          </div>
          <div className="highlight-text">कम प्रीमियम</div>
        </div>
      </div>

      <div className="pmsby-content">
        <div className="pmsby-card feature-card">
          <div className="card-header">
            <div className="card-icon-container">
              <FaShieldAlt className="card-icon" />
            </div>
            <h2>योजना के बारे में</h2>
          </div>
          <div className="card-body">
            <p>
              प्रधानमंत्री सुरक्षा बीमा योजना (PMSBY) भारत सरकार द्वारा संचालित एक सामाजिक सुरक्षा योजना है जो सभी भारतीय नागरिकों को सस्ती दर (मात्र ₹12/वर्ष) पर दुर्घटना बीमा कवर प्रदान करती है।
            </p>
          </div>
        </div>

        <div className="pmsby-card feature-card">
          <div className="card-header">
            <div className="card-icon-container">
              <FaRupeeSign className="card-icon" />
            </div>
            <h2>मुख्य लाभ</h2>
          </div>
          <div className="card-body">
            <ul>
              <li>दुर्घटना में मृत्यु पर <strong>₹2 लाख</strong> का कवर</li>
              <li>पूर्ण स्थायी विकलांगता पर <strong>₹2 लाख</strong></li>
              <li>आंशिक स्थायी विकलांगता पर <strong>₹1 लाख</strong></li>
              <li>बीमा अवधि: <strong>1 जून से 31 मई</strong> तक</li>
              <li><strong>18-70 वर्ष</strong> आयु वर्ग के लिए</li>
              <li>बैंक खाते से <strong>स्वतः प्रीमियम</strong> कटौती</li>
            </ul>
          </div>
        </div>

        <div className="pmsby-card feature-card">
          <div className="card-header">
            <div className="card-icon-container">
              <FaUserCheck className="card-icon" />
            </div>
            <h2>पात्रता शर्तें</h2>
          </div>
          <div className="card-body">
            <ul>
              <li><strong>18-70 वर्ष</strong> आयु के भारतीय नागरिक</li>
              <li>किसी भी बैंक में <strong>बचत खाता</strong> होना अनिवार्य</li>
              <li>विशेष रूप से <strong>असंगठित क्षेत्र</strong> के श्रमिकों के लिए</li>
              <li>किसी <strong>चिकित्सकीय जाँच</strong> की आवश्यकता नहीं</li>
            </ul>
          </div>
        </div>

        <div className="pmsby-card feature-card">
          <div className="card-header">
            <div className="card-icon-container">
              <FaFileSignature className="card-icon" />
            </div>
            <h2>आवेदन प्रक्रिया</h2>
          </div>
          <div className="card-body">
            <div className="steps-container">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-content">अपनी बैंक शाखा में जाएँ या नेट बैंकिंग के माध्यम से आवेदन करें</div>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-content">आवेदन फॉर्म भरें (शाखा पर उपलब्ध या बैंक वेबसाइट से डाउनलोड करें)</div>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-content">आधार कार्ड नंबर प्रदान करें</div>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <div className="step-content">प्रीमियम स्वतः कटौती हेतु सहमति दें</div>
              </div>
            </div>
            <div className="enrollment-note">
              * आवेदन हेतु अवधि: प्रतिवर्ष 1 जून से 31 मई तक
            </div>
          </div>
        </div>
      </div>

      <div className="pmsby-cta">
        <div className="cta-content">
          <h2>किसानों एवं पशुपालकों के लिए संपूर्ण सुरक्षा</h2>
          <p>
            PMSBY आपको व्यक्तिगत दुर्घटना सुरक्षा प्रदान करती है, जबकि हमारी पशुधन बीमा योजना आपके पशुधन एवं आजीविका की रक्षा करती है। दोनों योजनाएँ मिलकर ग्रामीण परिवारों को वित्तीय सुरक्षा प्रदान करती हैं।
          </p>
          <div className="cta-buttons">
            <button className="cta-button primary">
              पशुधन बीमा के बारे में अधिक जानें
            </button>
            <button className="cta-button secondary">
              PMSBY जानकारी पत्रक डाउनलोड करें
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PmsbyScheme;